import { render, staticRenderFns } from "./TemporaryKey.vue?vue&type=template&id=72ec2ed8"
import script from "./TemporaryKey.vue?vue&type=script&lang=js"
export * from "./TemporaryKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports